















































































































































































import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import {Vue, Prop, Component} from 'vue-property-decorator';
import axios from 'axios';
import {Ax} from "@/utils";
import VueElementLoading from "vue-element-loading";
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import {BootstrapVueIcons} from 'bootstrap-vue';
import app9ReasonInput from "@/modules/budget/monitoring/input-forms/components/application9/app9ReasonInput.vue";
import popUp from "@/modules/budget/monitoring/input-forms/components/popUp.vue";
import { noAbc, nextInput } from "@/modules/budget/monitoring/input-forms/common/formaters"


interface App9Request {
    currForm: any
    cutness: number
    region: string
    repdate: string
    date_420: string|null
    user_id: string
    abp: number|null
    convert: number|string|null
    year: number
    month: number
    status: boolean
    form: string
    form_id: number
    locale?: string
    period?: string
    pull_existing?: boolean,
    show_subventions?: boolean
}

Vue.use(BootstrapVueIcons);
@Component({
    computed: {},
    components: {
        'loading': VueElementLoading,
        'treeselect': Treeselect,
        'reason-input': app9ReasonInput,
        'pop-up': popUp,
    },
    filters: {
        formatDate(value: any) {
            if (value) {
                const date = new Date(value*1000);
                return date.toLocaleDateString();
            }
            return null;
        }
    }
})
export default class ApplcationForm9 extends Vue {
    $refs!: {
        reasonInputForm: HTMLFormElement
    }
    private cutness: any = {code: 1};
    @Prop({
        required: false,
        default: null
    })
    private date_to!:Date;
    @Prop({
        required: true,
        default: null
    })
    private date_420!:Date;
    @Prop({
        required: false,
        default: ''
    })
    private user_id!:any;
    @Prop({
        required: false,
        default: null
    })
    private period!:any;
    @Prop({
        required: false,
        default: 1000, // Set the desired default here
    })
    private convert!:any;
    @Prop({
        required: true,
        default: null
    })
    private currForm!:any;
    @Prop({
        required: true,
        default: null
    })
    private reportFormView!:any;
    @Prop({
        required: true,
        default: null
    })
    private editAccess!:any;
    @Prop({
        required: true,
        default: null
    })
    private deleteAccess!:any;
    @Prop({
        required: true,
        default: null
    })
    private childStatus!:any;
    @Prop({
        required: true,
        default: null
    })
    private showSubventions!:any;

    private loading: boolean = false;

    private showAbpInfo: boolean = false; //модальное информанионное окно
    private infoAbp:any = {}
    private cbcRegions: any[] = []

    private showReasonInput: boolean = false;

    private funcDict: any = {};
    private spfDict: any = {};
    private currProgData: any[] = [];
    private currProgTreeData: any[] = [];
    private devProgData: any[] = [];
    private devProgTreeData: any[] = [];

    // справочник причин грузит BEIFOpenWindow, форма монтируется после его загрузки
    @Prop({
        required: false,
        default: () => []
    })
    private reasonsFull!: any[];

    @Prop({
        required: false,
        default: () => ({})
    })
    private dictReasons!: any;
    // Приложения 6 и 7 (не формы ожидаемого исполнения): здесь ФЛК делится на области «Платежи» / «Обязательства»
    private get isBaseForm(): boolean {
        return ['app8', 'app9'].includes(this.currForm.form_code)
    }
    private spfTable:any = [];
    private userNames:any = {};
    private get numCols() {
        if (this.reportFormView) {
            if (['app8', 'app9'].includes(this.currForm.form_code)) {
                return [
                    'plg',
                    'obaz',
                    'plat',
                    'registrob',
                    ...this.showSubventions ? ['ob_subventions'] : [],
                    'sumrg',
                    ...this.showSubventions ? ['pl_subventions'] : [],
                    'expectation',
                    'sum_not_executed_payment',
                    'sum_discarded_oblig',
                ]
            } else {
                return [
                    'plg',
                    'obaz',
                    'plat',
                    'registrob',
                    'sumrg',
                    'execution_rate',
                    'sum_not_executed_payment',
                    'sum_discarded_oblig',
                    'execution_on_sum'
                ]
            }

        } else {
            if (['app8', 'app9'].includes(this.currForm.form_code)) {
                return [
                    'sum_discarded_oblig',
                    'sum_not_executed_payment',
                    'note_pl_reasonid',
                    'note_ob_reasonid'
                ]
            } else {
                return [
                    'execution_on_sum',
                    'execution_on_rate',
                    'execution_on_not_executed',
                    'note_obj_reasonid',
                    'note_sub_reasonid'
                ]
            }

        }
    }
    private inputFields:string[] = ['expectation', 'execution_on_sum', 'ob_subventions', 'pl_subventions']
    private totalSum:any = {}
    private isOnCreate:boolean = true;
    async created() {
        this.$emit('onRegisterFacade', this)
        const that = this;
        const sumFields:any[] = [
            'plg',
            'obaz',
            'plat',
            'registrob',
            'sumrg',
            'expectation',
            'savings_gz',
            'savings_fot',
            'savings_etc',
            'rez_gov',
            'nd_ob',
            'nd_contests',
            'nd_abp',
            'nd_etc',
            'execution_on_sum',
            'ob_subventions',
            'pl_subventions',
        ]
        const item = that.totalSum
        for (const val of sumFields) {
            Object.defineProperty(item, val, {
                get: function () {
                    return that.total(`${val}`)
                },
                set: function (value) {
                    item[`_${val}`] = value;
                }
            })
        }
        Object.defineProperty(item, 'sum_discarded_oblig', {
            get: function () {
                return that.total('sum_discarded_oblig')
            }
        })
        Object.defineProperty(item, 'execution_rate', {
            get: function () {
                if (item.plat === 0) return 0
                return parseFloat((item.sumrg / item.plat * 100).toFixed(3))
            }
        })
        Object.defineProperty(item, 'execution_expectation_rate', {
            get: function () {
                if (item.plg === 0) return 0
                return parseFloat((item.expectation / item.plg * 100).toFixed(3))
            }
        })
        Object.defineProperty(item, 'sum_not_executed_expec', {
            get: function () {
                return that.total('sum_not_executed_expec')
            }
        })
        Object.defineProperty(item, 'sum_not_executed_payment', {
            get: function () {
                return that.total('sum_not_executed_payment')
            }
        })
        Object.defineProperty(item, 'sum_econ', {
            get: function () {
                return that.total('sum_econ')
            }
        })
        Object.defineProperty(item, 'sum_unspent', {
            get: function () {
                return that.total('sum_unspent')
            }
        })
        Object.defineProperty(item, 'execution_on_rate', {
            get: function () {
                if (item.plat === 0) return 0
                return parseFloat((item.execution_on_sum / item.plat * 100).toFixed(3))
            }
        })
        Object.defineProperty(item, 'execution_on_not_executed', {
            get: function () {
                return item.execution_on_sum - item.plat
            }
        })
        this.$watch('childStatus', () => {
            if (this.childStatus && this.childStatus.hasOwnProperty('code') && !this.isOnCreate) {
                this.loadData()
            }
        }, {deep: true})
        this.$watch('date_420', () => {
            this.loadData()
        }, {deep: true})
    }
    private async mounted() {
        await this.loadData()
        this.isOnCreate = false;
    }

    private formatedDate(date_to: Date) {
        return `${date_to.getFullYear()}-${date_to.getMonth() + 1}-${date_to.getDate()}`
    }

    private async getData(pull_existing: boolean) {
        let treeS:any = {
            currTree: [],
            devTree: [],
            funcDict: {},
            spfDict: {}
        };
        const formatedDate = `${this.date_to.getFullYear()}-${this.date_to.getMonth() + 1}-${this.date_to.getDate()}`
        const request: App9Request = {
            'currForm': this.currForm,
            'cutness': 1, // cutness.code, для того чтобы видеть все спф и их суммы
            'region': this.currForm.region, //this.currForm
            'repdate': formatedDate, //this.currForm
            'date_420': null,
            'user_id': this.user_id,
            'abp': this.currForm.abp, //this.currForm
            'convert': this.convert,
            'year': this.currForm.year, //this.currForm
            'month': this.currForm.month, //this.currForm
            'status': this.childStatus && this.childStatus.hasOwnProperty('code') && this.childStatus.code? this.childStatus.code: null,
            'form': this.currForm.form_code, //this.currForm
            'form_id': this.currForm.id, //this.currForm
            'pull_existing': pull_existing,
            'show_subventions': this.showSubventions
        }
        if (this.currForm.form_code.includes('_ex')) {
            request.date_420 = `${this.date_420.getFullYear()}-${this.date_420.getMonth() + 1}-${this.date_420.getDate()}`
        }
        await axios.post('/api-py/fulfillment-report/app-9/data', request).then(resp => {
            if (resp.status === 200) {
                treeS = resp.data;
            }
        }).catch(error => {
        })
        return treeS
    }

    private async loadUsernames() {
        for (const u in this.userNames) {
            try {
                await axios.get(`/api-py/get-realm-user/${u}`).then(resp => {
                    if (resp.status === 200) {
                        this.userNames[u] = resp.data.firstName + ' ' + resp.data.lastName
                    }

                })
            } catch (e) {

            }
        }
    }
    private user_name(uuid:string) {
        if (uuid in this.userNames) {
            return this.userNames[uuid]
        }
        return ''
    }


    public async loadData(pull_existing: boolean = false) {
        this.loading = true
        const that = this
        try {
            const treeS:any = await this.getData(pull_existing)
            this.collapse = true;
            this.currProgData = treeS.currTree
            this.devProgData = treeS.devTree
            this.funcDict = treeS.funcDict
            this.spfDict = treeS.spfDict

            that.currProgTreeData = that.createTree(that.currProgData, this.funcDict, this.spfDict)
            that.devProgTreeData = that.createTree(that.devProgData, this.funcDict, this.spfDict)
            that.loading = false
            this.loadUsernames()
            if (!pull_existing) {
                await this.updateFormFlk()
            }
        } catch (e) {
            that.loading = false
        }
    }

    private async saveData(abpEll:any=null) {
        const flk_rows: any[] = []
        const dataSet:any[] = []
        for (const el of this.currProgTreeData.concat(this.devProgTreeData)) {
            if (['app9_ex', 'app8_ex'].includes(this.currForm.form_code) && el.flk1) {
                flk_rows.push(el.ppr_key)
                continue
            }
            if (['app9_ex', 'app8_ex'].includes(this.currForm.form_code)) {
                el.ob_subventions = null
                el.pl_subventions = null
            }
            dataSet.push(el)
        }
        if (flk_rows.length) {
            this.makeToast(
                'danger',
                this.$t('modules.common.error'),
                this.$t('modules.budget_execution_monitoring.reports.app_9.warn_non_exec_flk')
                    .toString()
                    .replace('$cbc', flk_rows.join(', '))
            )
        }
        const req = {
            save_list: dataSet,
            repdate: this.formatedDate(this.date_to),
            region: this.currForm.region,
            form: this.currForm.form_code,
            user_id: this.user_id
        }
        await axios.post('/api-py/fulfillment-report/app-9/data/save', req).then(resp => {
            if (resp.status === 200) {
                for (const cbc of this.currProgTreeData) {
                    if (cbc.hasChanges) {
                        cbc.hasChanges = false
                    }
                }
                for (const cbc of this.devProgTreeData) {
                    if (cbc.hasChanges) {
                        cbc.hasChanges = false
                    }
                }

                this.makeToast('success', this.$t('modules.common.saving'), this.$t('modules.common.data_saved_successfully'))
                this.loadData()
            }
        })
    }
    private collapse: boolean = true;

    private clkCollapseAll(data: any, collapse = true) {
        this.$set(data, 'collapse', collapse);
        if ('child_list' in data && data.child_list && data.child_list.length) {
            for (const el of data.child_list) {
                this.clkCollapseAll(el, collapse)
            }
        }
    }

    private clkCollapse(abp: any = null, prg: any = null, ppr: any = null, spf: any = null, collapse: boolean = false, dev_type = 0) {
        if (abp !== null) {
            let obj = !dev_type ? this.currProgTreeData[abp] : this.devProgTreeData[abp]
            if (prg !== null) {
                obj = obj.child_list[prg]
            }
            if (ppr !== null) {
                obj = obj.child_list[ppr]
            }
            if (collapse) {
                this.clkCollapseAll(obj, collapse)
            }
            this.$set(obj, 'collapse', collapse);
        } else {
            this.collapse = collapse;
            for (const el of this.currProgTreeData) {
                this.clkCollapseAll(el, collapse)
            }
            for (const el of this.devProgTreeData) {
                this.clkCollapseAll(el, collapse)
            }

        }
    }
    private total(field: string) {
        let sum = 0
        for (const el of this.currProgTreeData.concat(this.devProgTreeData)) {
            sum += el[field]
        }
        return sum
    }
    private downloadRep(rep_type:number = 4) {
        // this.loading = true
        const formatedDate = `${this.date_to.getFullYear()}-${this.date_to.getMonth() + 1}-${this.date_to.getDate()}`
        const request:App9Request = {
            'currForm': this.currForm,
            'cutness': 0,
            'region': this.currForm.region,
            'repdate': formatedDate,
            'date_420': null,
            'user_id': this.user_id,
            'abp': this.currForm.abp,
            'period': this.period,
            'locale': this.$i18n.locale,
            'convert': this.convert,
            'year': this.currForm.year,
            'month': this.currForm.month,
            'status': this.childStatus && this.childStatus.hasOwnProperty('code') && this.childStatus.code? this.childStatus.code: null,
            'form': this.currForm.form_code,
            'form_id': this.currForm.id,
            'show_subventions': this.showSubventions
        }
        if (this.currForm.form_code.includes('_ex')) {
            request.date_420 = `${this.date_420.getFullYear()}-${this.date_420.getMonth() + 1}-${this.date_420.getDate()}`
        }
        const that = this
        try {
            this.makeToast('info', this.$t('modules.common.attention'), this.$t('modules.budget_execution_monitoring.reports.app_9.warn_download'));
            Ax(
                {
                    url: `/api-py/fulfillment-report/app-9/report/${rep_type}`,
                    method: 'POST',
                    responseType: 'blob',
                    data: request
                },
                (data: any) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    let name = that.$t('modules.budget_execution_monitoring.reports.app_9.app9')
                    if (rep_type === 1) name = that.$t('modules.budget_execution_monitoring.reports.app_9.app9_analysis')
                    if (rep_type === 2) name = that.$t('modules.budget_execution_monitoring.reports.app_9.app9_reason_info')
                    if (rep_type === 3) name = that.$t('modules.budget_execution_monitoring.reports.app_9.app9_analysis_wide')
                    if (rep_type === 8) name = that.$t(`modules.budget_execution_monitoring.reports.app_9.${that.currForm.form_code}_form_8`)
                    if (rep_type === 9) name = that.$t(`modules.budget_execution_monitoring.reports.app_9.app9${that.currForm.form_code.includes('ex')? '_ex': ''}_form_9`)
                    if (rep_type === 10) name = that.$t('modules.budget_execution_monitoring.reports.app_9.app9_ex_form_10')
                    link.setAttribute('download', name + '.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    that.loading = false
                },
                (error) => {
                    that.loading = false
                    this.makeToast('danger', 'Ошибка запроса downloadRep()', error.toString());
                }
            );
        } catch (error) {
            that.loading = false
            this.makeToast('danger', this.$t('modules.common.warning'), this.$t('modules.budget_execution_monitoring.reports.app_9.warn_filter'));
        }
    }

    public downloadApp9Report() {
        this.downloadAppExcel(9, 'app9')
    }

    public downloadApp10Report() {
        this.downloadAppExcel(10, 'app10')
    }

    // Общая выгрузка годовых Excel-отчётов (Приложения 9, 10): отчётный год = год формы - 1
    private downloadAppExcel(appNum: number, code: string) {
        this.loading = true
        const that = this
        const year: string = (this.currForm.year - 1).toString()
        
        try {
            this.makeToast('info', this.$t('modules.common.attention'), this.$t('modules.budget_execution_monitoring.reports.app_9.warn_download'))
            
            const params = new URLSearchParams()
            params.set('year', year)
            params.set('region', this.currForm.region)
            params.set('locale', this.$i18n.locale)

            Ax(
                {
                    url: `/api-py/application/input-forms/${appNum}/export?${params}`,
                    method: 'get',
                    responseType: 'blob',
                },
                (data: any) => {
                    const url = window.URL.createObjectURL(new Blob([data]))
                    const link = document.createElement('a')
                    link.href = url
                    const formName = String(
                        this.$t(`modules.budget_execution_monitoring.reports.${code}._filenames.${code}`)
                    ).replace('$year', year)
                    link.setAttribute('download', formName + '.xlsx')
                    document.body.appendChild(link)
                    link.click()
                    that.loading = false
                },
                (error, reason) => {
                    that.loading = false
                    // 400 по Приложению 10 — узловой регион XX0000/XXYY00, по нему отчёт не формируется
                    if (appNum === 10 && reason?.response?.status === 400) {
                        this.makeToast('danger', this.$t('modules.common.warning'), this.$t('modules.budget_execution_monitoring.reports.app10._errors.node_region'))
                        return
                    }
                    this.makeToast('danger', 'Ошибка запроса downloadRep()', error.toString());
                }
            )
        } catch (error) {
            that.loading = false
            this.makeToast('danger', this.$t('modules.common.warning'), this.$t('modules.budget_execution_monitoring.reports.app_9.warn_filter'))
        }
    }

    private FORMULA:any = {
        'sum_discarded_oblig': ['($registrob - $obaz)', ['registrob', 'obaz']],
        'execution_rate': ['($sumrg / $plat)$mult100', ['sumrg', 'plat']],
        'execution_on_rate': ['($execution_on_sum / $plat)$mult100', ['execution_on_sum', 'plat']],
        'execution_expectation_rate': ['($expectation / $plg)$mult100', ['expectation', 'plg']],
        'execution_on_not_executed': ['($execution_on_sum - $plat)', ['execution_on_sum', 'plat']],
        'sum_not_executed_expec': ['($expectation - $plg)', ['expectation', 'plg']],
        'sum_not_executed_payment': ['($sumrg - $plat)', ['sumrg', 'plat']],
        'sum_econ': ['($savings_gz + $savings_fot + $savings_etc)', ['savings_gz', 'savings_fot', 'savings_etc']],
        'sum_unspent': ['($sum_not_executed_payment - $sum_econ - $rez_gov)', ['sum_not_executed_payment', 'sum_econ', 'rez_gov']],
    }
    private ADD:any = {
        'col': { 'ru': 'ст $col', 'kk': '$col - бағ.', 'en': 'graph $col' },
        'mult': { 'ru': 'x', 'kk': '*', 'en': 'x' }
    }

    private getHeaderWithFormula(h:string) {
        let colText = this.$t(`modules.budget_execution_monitoring.reports.app_9.table.${h}`);
        const col = this.ADD['col'][this.$i18n.locale]
        const mult = this.ADD['mult'][this.$i18n.locale]

        if (this.FORMULA.hasOwnProperty(h)) {
            const formula:any[] = this.FORMULA[h];
            let pattern = formula[0];
            const requier:any[] = formula[1];
            let favalable = true;

            for (const r of requier) {
                if (!this.numCols.includes(r)) {
                    favalable = false;
                    break;
                }
            }

            if (favalable) {
                for (const r of requier) {
                    const ridx = this.numCols.indexOf(r) + 1;
                    pattern = pattern.replace(`$${r}`, col.replace('$col', ridx));
                }
                pattern = pattern.replace('$mult', mult);
                colText = `${colText} ${pattern}`;
            }
        }

        return colText;
    }

    private createReasonsTree(type:any = null, obaz_plat:any = 1) {
        const dict_ob:any = {}
        const dict_pl:any = {}
        for (const r of this.reasonsFull) {
            if (type !== null) {
                if (r.type !== type && r.type !== 3) {
                    continue
                }
            }
            if (!dict_ob[r.gr_ob_id]) {
                dict_ob[r.gr_ob_id] = {
                    id: r.gr_ob_id.toString(),
                    label: r[`gr_ob_name_${this.$i18n.locale}`],
                    children: [],
                    value: Object.assign({}, r)
                }
            }
            if (!dict_pl[r.gr_pl_id]) {
                dict_pl[r.gr_pl_id] = {
                    id: r.gr_pl_id.toString(),
                    label: r[`gr_pl_name_${this.$i18n.locale}`],
                    children: [],
                    value: Object.assign({}, r)
                }
            }
            dict_ob[r.gr_ob_id].children.push({
                id: `${r.gr_ob_id}_${r.id}`,
                label: r[`name_${this.$i18n.locale}`],
                value: Object.assign({}, r)
            })
            dict_pl[r.gr_pl_id].children.push({
                id: `${r.gr_pl_id}_${r.id}`,
                label: r[`name_${this.$i18n.locale}`],
                value: Object.assign({}, r)
          })

        }
        if (obaz_plat === 1) return Object.values(dict_ob)
        else return Object.values(dict_pl)
    }

    private async loadSPFTable() {
        await axios.get('/api-py/fulfillment-report/app-9/spf-table').then(resp => {
            if (resp.status === 200) {
                this.spfTable = resp.data
            }
        })
    }

    private reasonText(id:number) {
        const it = this.reasonsFull.find((v:any) => v.id === id)
        const l_name = `name_${this.$i18n.locale}`
        if (it) return it[l_name]
        else return 1
    }
    private makeToast(variant: any, title: any, tostbody: any) {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            toaster: 'b-toaster-top-center',
            autoHideDelay: 5000,
            appendToast: true
        });
    }
    private reSum(item:any, field:string) {
        let sum = 0;
        if (field[0] === '_') {
            field = field.replace('_', '');
        }
        for (const ch1 of item.child_list) {
            sum += ch1[field]
        }
        return sum

    }

    private calcFields(item:any, sum:boolean = true) {
        const that = this;
        const sumFields:any[] = [
            'plg',
            'obaz',
            'plat',
            'registrob',
            'sumrg',
            'expectation',
            'savings_gz',
            'savings_fot',
            'savings_etc',
            'rez_gov',
            'nd_ob',
            'nd_contests',
            'nd_abp',
            'nd_etc',
            'execution_on_sum',
            'ob_subventions',
            'pl_subventions',
        ]
        if (sum) {
            for (const val of sumFields) {
                Object.defineProperty(item, val, {
                    get: function () {
                        return that.reSum(item, `_${val}`)
                    },
                    set: function (value) {
                        item[`_${val}`] = value;
                    }
                })
            }
            for (const flkKey of ['flk1', 'flk2', 'flk3', 'flk4', 'flkS1', 'flkS2']) {
                Object.defineProperty(item, flkKey, {
                    get: function () {
                        for (const ch of item.child_list) {
                            if (ch[flkKey]) return true;
                        }
                        return false;
                    }
                })
            }
            Object.defineProperty(item, 'status', {
                get: function () {
                    for (const ch of item.child_list) {
                        if (!ch.status) return false;
                    }
                    return true;
                },
                set: function (value) {
                    for (const ch of item.child_list) {
                        ch.status = value
                    }
                }
            })
            Object.defineProperty(item, 'flk', {
                get: function () {
                    return item.flk1 || item.flk2 || item.flk3 || item.flk4 || item.flkS1 || item.flkS2
                }
            })
            Object.defineProperty(item, 'flkPay', {
                get: function () {
                    return that.flkPay(item)
                }
            })
            Object.defineProperty(item, 'flkOb', {
                get: function () {
                    return that.flkOb(item)
                }
            })
        } else { // ppr node level
            const sumR:string[] = ['savings_gz', 'savings_fot', 'savings_etc', 'rez_gov', 'nd_ob', 'nd_contests', 'nd_abp', 'nd_etc']
            for (const f of sumFields) {
                if (!sumR.includes(f)) item[f] = parseFloat(item[f].toFixed(3));
            }
            for (let i = 1; i < 10; i++) {
                const f = sumR[i-1]
                Object.defineProperty(item, f, {
                    get: function () {
                        let sum = 0
                        for (const r_id in item.note_pl_reasonid) {
                            if (r_id in that.dictReasons) {
                                const reason = that.dictReasons[r_id]
                                if (reason.gr_pl_id === i) {
                                    sum += item.note_pl_reasonid[r_id]
                                }
                            }
                        }
                        return parseFloat(sum.toFixed(3))
                    }
                });
            }
            Object.defineProperties(item, {
                'flk1': {
                    get: function () {
                        return that.flk1(item)
                    }
                },
                'flk2': {
                    get: function () {
                        return that.flk2(item)
                    }
                },
                'flk3': {
                    get: function () {
                        return that.flk1(item, false)
                    }
                },
                'flk4': {
                    get: function () {
                        return that.flk2(item, false)
                    }
                },
                'flkS1': {
                    get: function () {
                        return that.flkSubvention(item, 'ob_subventions')
                    }
                },
                'flkS2': {
                    get: function () {
                        return that.flkSubvention(item, 'pl_subventions')
                    }
                },
                'flk': {
                    get: function () {
                        return item.flk1 || item.flk2 || item.flk3 || item.flk4 || item.flkS1 || item.flkS2
                    }
                },
                'flkPay': {
                    get: function () {
                        return that.flkPay(item)
                    }
                },
                'flkOb': {
                    get: function () {
                        return that.flkOb(item)
                    }
                },
                'status': {
                    get: function () {
                        return item._status
                    },
                    set: function (value) {
                        item._status = value
                        that.chgValue(item, 'status', item.develop_type, 3)
                    }
                }
            })
        }
        Object.defineProperty(item, 'sum_discarded_oblig', {
            get: function () {
                return item.registrob - item.obaz
            }
        })
        Object.defineProperty(item, 'execution_rate', {
            get: function () {
                if (item.plat === 0) return 0
                return parseFloat((item.sumrg / item.plat * 100).toFixed(3))
            }
        })
        Object.defineProperty(item, 'execution_on_rate', {
            get: function () {
                if (item.plat === 0) return 0
                return parseFloat((item.execution_on_sum / item.plat * 100).toFixed(3))
            }
        })
        Object.defineProperty(item, 'execution_expectation_rate', {
            get: function () {
                if (item.plg === 0) return 0
                return parseFloat((item.expectation / item.plg * 100).toFixed(3))
            }
        })
        Object.defineProperty(item, 'sum_not_executed_expec', {
            get: function () {
                return item.expectation - item.plg
            }
        })
        Object.defineProperty(item, 'execution_on_not_executed', {
            get: function () {
                return item.execution_on_sum - item.plat
            }
        })
        Object.defineProperty(item, 'sum_not_executed_payment', {
            get: function () {
                return item.sumrg - item.plat
            }
        })
        Object.defineProperty(item, 'sum_econ', {
            get: function () {
                return item.savings_gz + item.savings_fot + item.savings_etc
            }
        })
        Object.defineProperty(item, 'sum_unspent', {
            get: function () {
                return item.sumrg - item.plat - item.sum_econ - item.rez_gov
            }
        })



    }
    private createTree(tableData: any[], funcDict:any, spfDict:any) {

        const tree:any = {}
        for (const [idx, item] of tableData.entries()) {
            if (!(item.user_id in this.userNames && item.user_id) && item.update_date) {
                this.userNames[item.user_id] = '';
            }

            const newItem = Object.assign({idx: idx, collapse: this.collapse}, item)
            const dev_type = newItem.develop_type
            const abp:number = newItem.abp
            const prg:number = newItem.prg
            const ppr:number = newItem.ppr
            const ppr_key:string = `${abp.toString().padStart(3, '0')} ${prg.toString().padStart(3, '0')} ${ppr? ppr.toString().padStart(3, '0'): '000'}`
            let pprNode = tree[ppr_key]
            if (!pprNode) {
                // '_note_pl_reasonid_eco'
                // '_note_ob_reasonid_eco'
                // '_note_pl_reasonid_und'
                // '_note_ob_reasonid_und'

                pprNode = Object.assign({idx: idx, collapse: this.collapse, child_list: []}, newItem)
                pprNode._note_pl_reasonid_eco = this.reasonsFull.filter((v:any) => v.id in pprNode.note_pl_reasonid && (v.type === 2 || v.type === 3)).map((x:any) => `${x.gr_pl_id}_${x.id}`)
                pprNode._note_ob_reasonid_eco = this.reasonsFull.filter((v:any) => v.id in pprNode.note_ob_reasonid && (v.type === 2 || v.type === 3)).map((x:any) => `${x.gr_ob_id}_${x.id}`)
                pprNode._note_pl_reasonid_und = this.reasonsFull.filter((v:any) => v.id in pprNode.note_pl_reasonid && (v.type === 1 || v.type === 3)).map((x:any) => `${x.gr_pl_id}_${x.id}`)
                pprNode._note_ob_reasonid_und = this.reasonsFull.filter((v:any) => v.id in pprNode.note_ob_reasonid && (v.type === 1 || v.type === 3)).map((x:any) => `${x.gr_ob_id}_${x.id}`)
                pprNode._status = pprNode.status
                pprNode.ppr_key = ppr_key
                this.calcFields(pprNode, false)
                tree[ppr_key] = pprNode
            }
            if (funcDict) {
                if (abp in funcDict) {
                    if (funcDict[abp] && funcDict[abp].child_list && prg in funcDict[abp].child_list) {
                        if (funcDict[abp].child_list[prg].child_list && ppr in funcDict[abp].child_list[prg].child_list) {
                            if (!pprNode.name_ru && funcDict[abp].child_list[prg].child_list[ppr] && funcDict[abp].child_list[prg].child_list[ppr].name_ru) {
                                pprNode.name_ru = funcDict[abp].child_list[prg].child_list[ppr].name_ru;
                                pprNode.name_kk = funcDict[abp].child_list[prg].child_list[ppr].name_kk;
                            }
                        }
                    }
                }
            }

        }
        return Object.values(tree).sort((a:any, b:any) => a['ppr_key'].localeCompare(b['ppr_key']))

    }


    private flk1(pprNode:any, base: boolean = true) {
        if (['app8_ex', 'app9_ex'].includes(this.currForm.form_code)) {
            return !(parseFloat(pprNode.plat.toFixed(3)) >= parseFloat(pprNode.execution_on_sum.toFixed(3)))
        } else {
            if (base) {
                return parseFloat((pprNode.registrob - pprNode.obaz).toFixed(3)) !== this.reasonSum(pprNode, 'note_ob_reasonid')
            } else {
                return !(parseFloat(pprNode.plg.toFixed(3)) >= parseFloat(pprNode.expectation.toFixed(3)))
            }

        }
    }
    private flk2(pprNode:any, base: boolean = true) {
        if (['app8_ex', 'app9_ex'].includes(this.currForm.form_code)) {
            return !(parseFloat(pprNode.execution_on_sum.toFixed(3)) >= parseFloat(pprNode.sumrg.toFixed(3)))
        } else {
            if (base) {
                return parseFloat((pprNode.sumrg - pprNode.plat).toFixed(3)) !== this.reasonSum(pprNode, 'note_pl_reasonid')
            } else {
                return !(parseFloat(pprNode.expectation.toFixed(3)) >= parseFloat(pprNode.sumrg.toFixed(3)))
            }

        }
    }
    // Сумма причин строки по словарю (причины вне справочника на дату не учитываются)
    private reasonSum(pprNode: any, key: string): number {
        let sum = 0
        const reasons = pprNode[key] || {}
        for (const r in reasons) {
            if (r in this.dictReasons) sum += reasons[r];
        }
        return parseFloat(sum.toFixed(3))
    }
    // Область «Платежи»: причины по платежам, ожидаемое > плана, ожидаемое < оплаченного, субвенции по платежам.
    // В формах ожидаемого исполнения (_ex) деления нет — любая ошибка считается «Платежами» (красная строка, как раньше)
    private flkPay(el: any): boolean {
        if (!this.isBaseForm) return el.flk
        return el.flk2 || el.flk3 || el.flk4 || el.flkS2
    }
    // Область «Обязательства»: причины по обязательствам, субвенции по обязательствам
    private flkOb(el: any): boolean {
        if (!this.isBaseForm) return false
        return el.flk1 || el.flkS1
    }
    private popupVariant(col: string): string {
        if (this.isBaseForm && ['registrob', 'sum_discarded_oblig', 'ob_subventions'].includes(col)) {
            return 'warning'
        }
        return 'danger'
    }
    // Подсказка расхождения причин: X — сумма причин области, Y — значение ячейки, Z — |X − Y|.
    // Суммы в ячейках и причинах отрицательные, в подсказке — по модулю (как на макете)
    private reasonsDiffText(el: any, reasonKey: string, col: string, textKey: string): string {
        const xRaw = this.reasonSum(el, reasonKey)
        const yRaw = parseFloat(el[col].toFixed(3))
        const x = Math.abs(xRaw)
        const y = Math.abs(yRaw)
        const z = parseFloat(Math.abs(xRaw - yRaw).toFixed(3))
        return this.$t(`modules.budget_execution_monitoring.reports.app_9.${textKey}`)
            .toString()
            .replace('$x', this.$n(x, 'decimalRound3'))
            .replace('$y', this.$n(y, 'decimalRound3'))
            .replace('$z', this.$n(z, 'decimalRound3'))
    }
    private flkSubvention(pprNode:any, field: string) {
        if (!this.showSubventions) {
            return false
        }
        if (field === 'ob_subventions') {
            return parseFloat(pprNode.ob_subventions.toFixed(3)) > parseFloat(pprNode.registrob.toFixed(3))
        } else if (field === 'pl_subventions') {
            return parseFloat(pprNode.pl_subventions.toFixed(3)) > parseFloat(pprNode.sumrg.toFixed(3))
        }
        return false
    }
    private showPopup(el: any, f:string) {
        if (['app9', 'app8'].includes(this.currForm.form_code)) {
            if (f === 'expectation') {
                return el.flk3 || el.flk4
            } else if (f === 'ob_subventions') {
                return el.flkS1
            } else if (f === 'pl_subventions') {
                return el.flkS2
            } else if (f === 'plg') {
                return el.flk3
            } else if (f === 'sum_discarded_oblig') {
                return el.flk1
            } else if (f === 'sum_not_executed_payment') {
                return el.flk2
            }
        } else {
            if (f === 'execution_on_sum') {
                return el.flk3 || el.flk4
            } else if (f === 'plat') {
                return el.flk3
            }
        }

        if (f === 'sumrg') {
            return el.flk4 || el.flkS2
        } else if (f === 'registrob') {
            return el.flkS1
        }
        return false
    }
    private showPopupText(el: any, f:string) {
        if (['app9', 'app8'].includes(this.currForm.form_code)) {
            if (f === 'expectation') {
                return el.flk3 || el.flk4 ? this.$t(`modules.budget_execution_monitoring.reports.app_9.warn_non_exec_${el.flk4 ? 'sumrg': 'plg'}`) : ''
            } else if (f === 'ob_subventions') {
                return el.flkS1 ? this.$t('modules.budget_execution_monitoring.reports.app_9.warn_ob_subventions') : ''
            } else if (f === 'pl_subventions') {
                return el.flkS2 ? this.$t('modules.budget_execution_monitoring.reports.app_9.warn_pl_subventions') : ''
            } else if (f === 'plg') {
                return el.flk3 ? this.$t(`modules.budget_execution_monitoring.reports.app_9.warn_non_exec_${f}`): ''
            } else if (f === 'sum_discarded_oblig') {
                return el.flk1 ? this.reasonsDiffText(el, 'note_ob_reasonid', f, 'warn_reasons_ob') : ''
            } else if (f === 'sum_not_executed_payment') {
                return el.flk2 ? this.reasonsDiffText(el, 'note_pl_reasonid', f, 'warn_reasons_pl') : ''
            }

        } else {
            if (f === 'execution_on_sum') {
                return el.flk3 || el.flk4 ?  this.$t(`modules.budget_execution_monitoring.reports.app_9.warn_non_exec_${el.flk4 ? 'sumrg': 'plat'}`) : ''
            } else if (f === 'plat') {
                return el.flk3 ? this.$t(`modules.budget_execution_monitoring.reports.app_9.warn_non_exec_${f}`): ''
            }
        }

        if (f === 'sumrg') {
            if (el.flk4) {
                return this.$t(`modules.budget_execution_monitoring.reports.app_9.warn_non_exec_${f}`)
            }
            if (el.flkS2) {
                return this.$t('modules.budget_execution_monitoring.reports.app_9.warn_pl_subventions')
            }
        } else if (f === 'registrob') {
            return el.flkS1 ? this.$t('modules.budget_execution_monitoring.reports.app_9.warn_ob_subventions') : ''
        }
        return ''
    }


    private flkAgree() {
        const arrData: any[] = this.currProgTreeData.concat(this.devProgTreeData)
        if (arrData.length === 0) {
            return false
        }
        for (const ppr of arrData) {
            if (ppr.flk1 || ppr.flk2 || ppr.flk3 || ppr.flk4 || ppr.flkS1 || ppr.flkS2) {
                return false
            }
        }
        return true
    }
    private async updateFormFlk() {
        if (
            (this.childStatus && this.childStatus.hasOwnProperty('code') && this.childStatus.code)
            || ([31, 26].includes(this.currForm.status.status))
        ) {
            return
        }
        const req:any = {
            flk: !this.flkAgree(),
            form_id: this.currForm.id
        }
        await axios.post('/api-py/input-forms/flk', req).catch(e => {})
    }

    private chgValue(pprObj: any, fieldName: any, dev_type: any, digit: number) {
        const value = pprObj[fieldName].toString().replace(/,/g, '.').replace(/ /g, '')
        const parsed = parseFloat(value);
        pprObj.hasChanges = true
        this.$set(pprObj, fieldName, isNaN(parsed) ? 0 : parseFloat(parsed.toFixed(digit)));
        if (!dev_type) {
            this.currProgData[pprObj.idx][fieldName] = pprObj[fieldName];
            this.currProgData[pprObj.idx].changed = true;
        } else {
            this.devProgData[pprObj.idx][fieldName] = pprObj[fieldName];
            this.devProgData[pprObj.idx].changed = true;
        }

    }

    async openCBCModal(val:any) {
        this.infoAbp = val
        const request: any = {
            'region': this.currForm.region,
            'repdate': `${this.date_to.getFullYear()}-${this.date_to.getMonth() + 1}-${this.date_to.getDate()}`,
            'date_420': null,
            'user_id': this.user_id,
            'func': val.func,
            'status': this.childStatus && this.childStatus.hasOwnProperty('code') && this.childStatus.code? this.childStatus.code: null,
            'form': this.currForm.form_code,
            'form_id': this.currForm.id
        }
        if (this.currForm.form_code.includes('_ex')) {
            request.date_420 = `${this.date_420.getFullYear()}-${this.date_420.getMonth() + 1}-${this.date_420.getDate()}`
        }
        await axios.post('/api-py/fulfillment-report/app-9/flk-regions', request).then(resp => {
            if (resp.status === 200) {
                this.cbcRegions = resp.data;
            }
        }).catch(error => {
        })
        this.showAbpInfo = true
    }
    private get downloadList() {
        const reportList: any[] = []

        const { form_code, region } = this.currForm

        const isApp8 = ['app8', 'app8_ex'].includes(form_code)
        const isApp9 = ['app9', 'app9_ex'].includes(form_code)
        const isEx = form_code.includes('ex')

        /** app9_ex + region */
        if (form_code === 'app9_ex' && region.slice(2) === '0000') {
            reportList.push({
                fn: this.downloadRep,
                args: [10],
                name: this.$t('modules.budget_execution_monitoring.reports.app_9.app9_ex_form_10'),
                idx: reportList.length
            })
        }

        /** app9 */
        if (form_code === 'app9') {
            reportList.push({
                fn: this.downloadRep,
                args: [4],
                name: this.$t('modules.budget_execution_monitoring.reports.app_9.app9'),
                idx: reportList.length
            })
        }

        /** app8 / app9 */
        if (['app8', 'app9'].includes(form_code)) {
            reportList.push({
                fn: this.downloadRep,
                args: [1],
                name: this.$t('modules.budget_execution_monitoring.reports.app_9.app9_analysis'),
                idx: reportList.length
            })
            reportList.push({
                fn: this.downloadRep,
                args: [2],
                name: this.$t('modules.budget_execution_monitoring.reports.app_9.app9_reason_info'),
                idx: reportList.length
            })
            reportList.push({
                fn: this.downloadRep,
                args: [3],
                name: this.$t('modules.budget_execution_monitoring.reports.app_9.app9_analysis_wide'),
                idx: reportList.length
            })
        }

        /** app8 / app8_ex */
        if (isApp8) {
            reportList.push({
                fn: this.downloadRep,
                args: [8],
                name: this.$t(`modules.budget_execution_monitoring.reports.app_9.${form_code}_form_8`),
                idx: reportList.length
            })
        }

        /** form 9 */
        if (
            isApp9 ||
            (isApp8 && parseInt(region.slice(5, 6)) > 1)
        ) {
            reportList.push({
                fn: this.downloadRep,
                args: [9],
                name: this.$t(
                    `modules.budget_execution_monitoring.reports.app_9.app9${isEx ? '_ex' : ''}_form_9`
                ),
                idx: reportList.length
            })
        }

        if (form_code === 'app9' && this.currForm?.month === 0) {
            reportList.push({
                fn: this.downloadApp9Report,
                args: [],
                name: this.$t('modules.budget_execution_monitoring.reports.app9.forms.app9'),
                idx: reportList.length
            })
        }

        // Приложение 10 строится только по одному бюджету — на узловых кодах XX0000/XXYY00 пункта нет
        if (form_code === 'app9' && this.currForm?.month === 0 && !this.currForm?.region?.endsWith('00')) {
            reportList.push({
                fn: this.downloadApp10Report,
                args: [],
                name: this.$t('modules.budget_execution_monitoring.reports.app10.forms.app10'),
                idx: reportList.length
            })
        }

        return reportList
    }

    private async pullExistingData() {
        await this.loadData(true)
    }
    // ------
    public onSaveReason() {
        if (this.$refs.reasonInputForm) {
            this.$refs.reasonInputForm.onSave()
        }
    }

    // close reason input
    private onReasonBack() {
        this.showReasonInput = false;
        this.$emit('onCloseReasons');
    }
    private async dataNotSaved() {
        let returnVal = false
        await this.$bvModal.msgBoxConfirm(
            this.$t('modules.budget_execution_monitoring.reports.app_9.unsaved_data_warning').toString(),
            {
                title: this.$t('modules.budget_execution_monitoring.reports.app_9.confirmation').toString(),
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.yes').toString(),
                cancelTitle: this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.cancellation').toString(),
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
            .then(value => {
                if (value) {
                    returnVal = true
                } else {
                    returnVal = false
                }
            })
            .catch(error => {
                this.makeToast('danger', this.$t('modules.budget_execution_monitoring.reports.app_9.save_error'), error.toString());
            });
        return returnVal
    }
    public async onBack() {
        if (this.currProgTreeData.concat(this.devProgTreeData).some(cbc => cbc.hasChanges)) {
            return await this.dataNotSaved()
        } else {
            return true
        }
    }
    private get any_form_data() {
        return this.currProgTreeData.length || this.devProgTreeData.length
    }

    // ------

    private noAbc: Function = noAbc
    private nextInput: Function = nextInput

    private getNextInputIndx(prgIdx: number, pprIdx: number, spfIndx: number, chldIndx: number | null) {
    }
    // ---------

    private inputFocus(event: any) {
        event.target.select();
    }

    private inputFixed(item: any, field: any, value: any, digit: any) {
        item.hasChanges = true
        if (value) {
            this.$set(item, field, parseFloat(parseFloat(value.toString().replace(/,/g, '.').replace(/ /g, '')).toFixed(digit)));
        } else {
            this.$set(item, field, 0);
        }
    }
}
